import healthList from 'src/apis/samples/health';

export function kindToName(kind: number) {
  const health = healthList.find(health => health.id === kind);
  return health?.title || '등록되지 않은 운동';
}
